'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Llocales_cldr_CalendarPatterns(datePatterns, timePatterns) {
  this.vH = null;
  this.vI = null;
  this.vH = datePatterns;
  this.vI = timePatterns;
}
export { $c_Llocales_cldr_CalendarPatterns as $c_Llocales_cldr_CalendarPatterns };
$p = $c_Llocales_cldr_CalendarPatterns.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Llocales_cldr_CalendarPatterns;
/** @constructor */
function $h_Llocales_cldr_CalendarPatterns() {
}
export { $h_Llocales_cldr_CalendarPatterns as $h_Llocales_cldr_CalendarPatterns };
$h_Llocales_cldr_CalendarPatterns.prototype = $p;
$p.I = (function() {
  return new $j_java$002elang$002e$002dObject.$c_s_Product$$anon$1(this);
});
$p.m = (function() {
  return $j_java$002elang$002e$002dObject.$m_s_util_hashing_MurmurHash3$().e7(this, (-889275714), null);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llocales_cldr_CalendarPatterns)) {
    var x = this.vH;
    var x$2 = x$0.vH;
    if (((x === null) ? (x$2 === null) : x.f(x$2))) {
      var x$3 = this.vI;
      var x$4 = x$0.vI;
      return ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.b = (function() {
  return $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().ah(this);
});
$p.n = (function() {
  return 2;
});
$p.o = (function() {
  return "CalendarPatterns";
});
$p.g = (function(n) {
  if ((n === 0)) {
    return this.vH;
  }
  if ((n === 1)) {
    return this.vI;
  }
  throw $j_java$002elang$002e$002dObject.$ct_jl_IndexOutOfBoundsException__T__(new $j_java$002elang$002e$002dObject.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Llocales_cldr_CalendarPatterns(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.dX)));
}
export { $isArrayOf_Llocales_cldr_CalendarPatterns as $isArrayOf_Llocales_cldr_CalendarPatterns };
var $d_Llocales_cldr_CalendarPatterns = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Llocales_cldr_CalendarPatterns, "locales.cldr.CalendarPatterns", ({
  dX: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Llocales_cldr_CalendarPatterns as $d_Llocales_cldr_CalendarPatterns };
